export default __webpack_public_path__ + "static/media/mute-audio-off.756f5ed2.svg";